let nextLineId = 0;

// Article codes identify products; line IDs identify independently editable rows.
export const newPurchaseLine = (item) => ({
  ...item,
  id: `purchase-line-${++nextLineId}`,
});

export const ensurePurchaseLineIds = (items = []) => items.map(item =>
  item.id === undefined || item.id === null ? newPurchaseLine(item) : item
);

export const purchaseLineTotals = (item) => {
  const quantity = Number(item.QTE) || 0;
  const discount = 1 - (Number(item.REMISE) || 0) / 100;
  return {
    ...item,
    TotalHT: quantity * (Number(item.PA_HT) || 0) * discount,
    TotalTTC: quantity * (Number(item.PA_TTC) || 0) * discount,
  };
};

// Average only the document's unit purchase prices, never existing stock.
// Keep the original document lines intact and send one price per article.
export const weightedPurchasePrices = (items = []) => {
  const groups = new Map();
  for (const item of items) {
    const quantity = Number(item?.QTE);
    if (!item?.CODE_ART || !Number.isFinite(quantity) || quantity <= 0) continue;
    const group = groups.get(item.CODE_ART) || { ...item, QTE: 0, valueHT: 0, valueTTC: 0 };
    group.QTE += quantity;
    group.valueHT += quantity * (Number(item.PA_HT) || 0);
    group.valueTTC += quantity * (Number(item.PA_TTC) || 0);
    groups.set(item.CODE_ART, group);
  }
  return [...groups.values()].map(({ valueHT, valueTTC, ...item }) => ({
    ...item,
    id: item.CODE_ART,
    PA_HT: valueHT / item.QTE,
    PA_TTC: valueTTC / item.QTE,
  }));
};
